import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconUsbC: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="usb-c, type-c"><path fillRule="evenodd" clipRule="evenodd" d="M0 12C0 8.68629 2.68629 6 6 6H18C21.3137 6 24 8.68629 24 12C24 15.3137 21.3137 18 18 18H6C2.68629 18 0 15.3137 0 12ZM5.75 11.25C5.33579 11.25 5 11.5858 5 12C5 12.4142 5.33579 12.75 5.75 12.75H18.25C18.6642 12.75 19 12.4142 19 12C19 11.5858 18.6642 11.25 18.25 11.25H5.75Z" fill="currentColor"/></CentralIconBase>;
};

export default IconUsbC;
